import { render, staticRenderFns } from "./ActionsStoryController.vue?vue&type=template&id=3962fb18&scoped=true&"
import script from "./ActionsStoryController.vue?vue&type=script&lang=ts&"
export * from "./ActionsStoryController.vue?vue&type=script&lang=ts&"
import style0 from "./ActionsStoryController.vue?vue&type=style&index=0&id=3962fb18&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3962fb18",
  null
  
)

export default component.exports